/** Path-only permalink for the speaker reader (no origin). */
export function speakerReaderPath(deckId: string): string {
  return `/deck/${deckId}/speaker`;
}

/** Build absolute permalink for the speaker reader view. */
export function speakerReaderPermalink(deckId: string): string {
  const path = speakerReaderPath(deckId);
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${path}`;
  }
  return path;
}

export async function copySpeakerReaderPermalink(deckId: string): Promise<boolean> {
  const url = speakerReaderPermalink(deckId);
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}
